module.exports = __webpack_public_path__ + "e44b827537eac68fab4303dae08f88ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/games/sm_image_mobile.jpg
// module id = 505
// module chunks = 0